<div class="page-wrapper">

  <!-- Page title -->
  <h1 class="page-title">{{ pageTitle }}</h1>

  <!-- Stepper -->
  <app-stepper [currentStep]="3"/>

  <!-- Main layout -->
  <div class="content-layout">

    <!-- Left: Main content -->
    <main class="main-content">

      <!-- Enrollment success card -->
      <div class="enrolled-card">
        <div class="enrolled-icon">
          <ngk-icon icon="circle-check" size="2.5rem" color="var(--color-secondary-600)"/>
        </div>
        <div class="enrolled-body">
          <p class="enrolled-title">You're enrolled. We've got it from here.</p>
          <p class="enrolled-desc">We will send you an email when your {{ filingNoun }} has been filed. To improve
            chances of winning your {{ filingNoun }}, you can add evidence below.</p>
          <div class="case-number-box">
            <div class="case-number-info">
              <span class="case-number-label">CASE NUMBER</span>
              <span class="case-number-value">{{ caseNumber }}</span>
            </div>
            <button class="copy-btn" (click)="copyCase()">{{ copied ? 'Copied!' : 'Copy' }}</button>
          </div>
        </div>
      </div>

      <!-- What happens next -->
      <div class="timeline-card card">
        <div class="timeline-card-header">
          <ngk-icon icon="list" size="1.1rem" color="var(--color-neutral-700)"/>
          <p class="timeline-card-title">What happens next</p>
        </div>

        <div class="timeline">
          @for (step of steps; track step.id; let last = $last) {
            <div class="timeline-item">
              <div class="timeline-step-col">
                @if (step.status === 'complete') {
                  <div class="timeline-circle timeline-circle--complete">
                    <ngk-icon icon="check" size="0.85rem"/>
                  </div>
                } @else if (step.status === 'active') {
                  <div class="timeline-circle timeline-circle--active">{{ step.step }}</div>
                } @else {
                  <div class="timeline-circle">{{ step.step }}</div>
                }
                @if (!last) {
                  <div class="timeline-connector" [class.timeline-connector--complete]="step.status === 'complete'"></div>
                }
              </div>
              <div class="timeline-content" [class.timeline-content--last]="last">
                <p class="timeline-title">{{ step.title }}</p>
                <p class="timeline-desc">{{ step.description }}</p>
                <p class="timeline-date">{{ step.date }}</p>
                @if (step.status === 'complete') {
                  <ngk-chip color="success" variant="solid" size="sm" prefixIcon="check">Complete</ngk-chip>
                } @else if (step.status === 'active') {
                  <ngk-chip color="secondary" variant="outlined" size="sm" prefixIcon="clock">In progress</ngk-chip>
                }
              </div>
            </div>
          }
        </div>
      </div>

      <!-- Notice of Protest upload -->
      <!--      <div class="appeal-notice-card" [class.appeal-notice-card&#45;&#45;uploaded]="appealNoticeUploaded">-->
      <!--        <div class="appeal-notice-header">-->
      <!--          <div class="appeal-notice-icon" [class.appeal-notice-icon&#45;&#45;uploaded]="appealNoticeUploaded">-->
      <!--            @if (appealNoticeUploaded) {-->
      <!--              <ngk-icon icon="circle-check" size="1.25rem" color="var(&#45;&#45;color-secondary-600)"/>-->
      <!--            } @else {-->
      <!--              <ngk-icon icon="alert-triangle" size="1.25rem"/>-->
      <!--            }-->
      <!--          </div>-->
      <!--          <div>-->
      <!--            <p class="appeal-notice-title">Upload your Notice of Appraised Value</p>-->
      <!--            <p class="appeal-notice-subtitle">-->
      <!--              This document is <strong>highly recommended</strong> to file your protest.-->
      <!--              You should have received it by mail from your county appraisal district.-->
      <!--            </p>-->
      <!--          </div>-->
      <!--        </div>-->

      <!--        <div class="appeal-notice-body">-->
      <!--          @if (appealNotice) {-->
      <!--            <div class="appeal-notice-file">-->
      <!--              <div class="uploaded-file-row">-->
      <!--                <ngk-icon icon="file-text" size="1rem" color="var(&#45;&#45;color-secondary-600)"/>-->
      <!--                <span class="uploaded-file-name">{{ appealNotice.filename }}</span>-->
      <!--                <button class="uploaded-file-remove" (click)="removeAppealNotice()" aria-label="Remove file">-->
      <!--                  <ngk-icon icon="trash-2" size="0.85rem" color="var(&#45;&#45;color-neutral-400)"/>-->
      <!--                </button>-->
      <!--              </div>-->
      <!--              <div class="appeal-notice-success">-->
      <!--                <ngk-icon icon="circle-check" size="0.85rem" color="var(&#45;&#45;color-secondary-600)"/>-->
      <!--                <span>Uploaded</span>-->
      <!--              </div>-->
      <!--              @if (appealNoticeError) {-->
      <!--                <p class="upload-error">{{ appealNoticeError }}</p>-->
      <!--              }-->
      <!--            </div>-->
      <!--          } @else if (appealNoticeUploading) {-->
      <!--            <div class="upload-uploading">-->
      <!--              <div class="upload-spinner"></div>-->
      <!--              <span>Uploading…</span>-->
      <!--            </div>-->
      <!--          } @else {-->
      <!--            <div class="appeal-notice-dropzone">-->
      <!--              <ngk-file-selector [multi]="false" [allowedExtensions]="['.jpg', '.jpeg', '.png', '.pdf']"-->
      <!--                                 [maxSize]="10485760" (filesChange)="onAppealNoticeChange($event)"/>-->
      <!--            </div>-->
      <!--            @if (appealNoticeError) {-->
      <!--              <p class="upload-error">{{ appealNoticeError }}</p>-->
      <!--            }-->
      <!--            <p class="appeal-notice-hint">-->
      <!--              <ngk-icon icon="info" size="0.8rem" color="var(&#45;&#45;color-warning-600)"/>-->
      <!--              It is highly encouraged to upload this document before your protest.-->
      <!--            </p>-->
      <!--          }-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- Add Info Section -->
      <h2 class="add-info-title">Help us build the strongest case for you</h2>
      <p class="add-info-subtitle">
        Homeowners who provide supporting evidence typically see better results. Upload anything that shows your home
        may be incorrectly valued.
        Examples of evidence to upload: Photos of damage, needed repairs, or outdated features. A recent appraisal or
        inspection report. Receipts for major repairs you've had to make.

      </p>

      <!-- Property conditions card -->
      <div class="conditions-card card">
        <div class="conditions-header">
          <div class="conditions-header-icon">
            <ngk-icon icon="wrench" size="1.1rem"/>
          </div>
          <div>
            <p class="conditions-title">Property conditions</p>
            <p class="conditions-subtitle">Select all that apply, or leave unchecked to skip</p>
          </div>
        </div>

        <div class="conditions-list">
          @for (item of conditions; track item.id; let last = $last) {
            <div class="condition-row" [class.condition-row--last]="last && !item.checked">
              <ngk-checkbox [(value)]="item.checked" (valueChange)="onConditionChange()">
                <div class="condition-label">
                  <div class="condition-label-top">
                    <span class="condition-title-text">{{ item.title }}</span>
                  </div>
                  <p class="condition-desc">{{ item.description }}</p>
                </div>
              </ngk-checkbox>
            </div>

            @if (item.checked) {
              <div class="condition-upload" [class.condition-upload--last]="last">
                @if (item.documents.length > 0) {
                  <div class="uploaded-files">
                    @for (doc of item.documents; track doc.id) {
                      <div class="uploaded-file-row">
                        <ngk-icon icon="file-text" size="1rem" color="var(--color-secondary-600)"/>
                        <span class="uploaded-file-name">{{ doc.filename }}</span>
                        <button class="uploaded-file-remove" (click)="removeConditionDocument(item, doc)"
                                aria-label="Remove file">
                          <ngk-icon icon="trash-2" size="0.85rem" color="var(--color-neutral-400)"/>
                        </button>
                      </div>
                    }
                  </div>
                }

                @if (item.uploadState === 'uploading') {
                  <div class="upload-uploading">
                    <div class="upload-spinner"></div>
                    <span>Uploading…</span>
                  </div>
                } @else {
                  <div class="upload-dropzone-wrapper">
                    <ngk-file-selector [multi]="true" [allowedExtensions]="['.jpg', '.jpeg', '.png', '.pdf']"
                                       [maxSize]="10485760" (filesChange)="onConditionFilesChange(item, $event)"/>
                  </div>
                }

                @if (item.uploadState === 'error') {
                  <p class="upload-error">{{ item.uploadError }}</p>
                }
              </div>
            }
          }
        </div>
        @if (conditionsError) {
          <p class="upload-error" style="padding: 0 var(--space-400) var(--space-300)">{{ conditionsError }}</p>
        }
      </div>

      <!-- Notes section -->
      <div class="notes-section">
        <div class="notes-header">
          <div class="notes-header-icon">
            <ngk-icon icon="message-square" size="1rem"/>
          </div>
          <div>
            <p class="notes-title">Anything else to add <span class="upload-optional">(optional)</span></p>
            <p class="add-info-subtitle"> Don't have anything handy right now? No problem, you can log back into your
              account at any time before {{ expectedFilingDate }} to add files.</p>
          </div>
        </div>
        <div class="notes-upload">


          @if (generalUploadState === 'uploading') {
            <div class="upload-uploading">
              <div class="upload-spinner"></div>
              <span>Uploading…</span>
            </div>
          } @else {
            <div class="upload-dropzone-wrapper">
              <ngk-file-selector [multi]="true" [allowedExtensions]="['.jpg', '.jpeg', '.png', '.pdf']"
                                 [maxSize]="10485760" (filesChange)="onGeneralFilesChange($event)"/>
            </div>
          }

          @if (generalUploadState === 'error') {
            <p class="upload-error">{{ generalUploadError }}</p>
          }

          <p class="notes-upload-label">Upload photos or documents <span class="upload-optional">(optional)</span></p>

          @if (generalDocuments.length > 0) {
            <div class="uploaded-files">
              @for (doc of generalDocuments; track doc.id) {
                <div class="uploaded-file-row">
                  <ngk-icon icon="file-text" size="1rem" color="var(--color-secondary-600)"/>
                  <span class="uploaded-file-name">{{ doc.filename }}</span>
                  <button class="uploaded-file-remove" (click)="removeGeneralDocument(doc)" aria-label="Remove file">
                    <ngk-icon icon="trash-2" size="0.85rem" color="var(--color-neutral-400)"/>
                  </button>
                </div>
              }
            </div>
          }
        </div>

        <div class="notes-body">
          <textarea
            class="notes-textarea"
            rows="4"
            placeholder="e.g. The back bedroom has had a persistent leak since 2021. We have contractor quotes but the work hasn't been done yet…"
            [(ngModel)]="noteText"
          ></textarea>
          @if (noteError) {
            <p class="note-error">{{ noteError }}</p>
          }
          @if (commentError) {
            <p class="note-error">{{ commentError }}</p>
          }
        </div>

        @if (comments.length > 0) {
          <div class="comments-list">
            <p class="comments-heading">Your comments</p>
            @for (comment of comments; track comment.id) {
              <div class="comment-row">
                <p class="comment-body">{{ comment.body }}</p>
                <button class="comment-remove" (click)="removeComment(comment)" aria-label="Remove comment">
                  <ngk-icon icon="x" size="0.85rem" color="var(--color-neutral-500)"/>
                </button>
              </div>
            }
          </div>
        }
      </div>

      <!-- Submit conditions button -->
      <button ngkButton color="secondary" mode="solid" size="md" class="submit-conditions-btn"
              (click)="submitConditions()">
        Add comment
      </button>

      <!-- Back link -->
      <button class="back-link" (click)="back()">← Back</button>
    </main>

    <!-- Right: Sidebar -->
    <app-property-sidebar/>
  </div>
</div>
